'use client'
import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import { slidesBrand, slidesTestimonail } from '../utilities/constant';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';
import Testimonial from '../component/Testimonial';

const page = () => {
    return (
        <>
            <Header />
            {/* <!-- Page Banner Start --> */}
            <div className="section page-banner-section"
                style={{ backgroundImage: " url(/images/bg/page-banner.jpg)" }}
            >
                <div className="shape-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="944px" height="894px">
                        <defs>
                            <linearGradient id="PSgrad_0" x1="88.295%" x2="0%" y1="0%" y2="46.947%">
                                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                                <stop offset="100%" stopColor="rgb(113,65,177)" stopOpacity="1" />
                            </linearGradient>

                        </defs>
                        <path fillRule="evenodd" fill="rgb(43, 142, 254)" d="M39.612,410.76 L467.344,29.824 C516.51,-13.476 590.638,-9.93 633.938,39.613 L914.192,317.344 C957.492,366.50 953.109,440.637 904.402,483.938 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z" />
                        <path fill="url(#PSgrad_0)" d="M39.612,410.76 L467.344,29.824 C516.51,-13.476 590.638,-9.93 633.938,39.613 L914.192,317.344 C957.492,366.50 953.109,440.637 904.402,483.938 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z" />
                    </svg>
                </div>
                <div className="shape-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="726.5px" height="726.5px">
                        <path fillRule="evenodd" stroke="rgb(255, 255, 255)" strokeWidth="1px" strokeLinecap="butt" strokeLinejoin="miter" opacity="0.302" fill="none" d="M28.14,285.269 L325.37,21.217 C358.860,-8.851 410.655,-5.808 440.723,28.14 L704.777,325.36 C734.846,358.859 731.802,410.654 697.979,440.722 L400.955,704.776 C367.132,734.844 315.338,731.802 285.269,697.978 L21.216,400.954 C-8.852,367.132 -5.808,315.337 28.14,285.269 Z" />
                    </svg>
                </div>
                <div className="shape-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="515px" height="515px">
                        <defs>
                            <linearGradient id="PSgrad_0" x1="0%" x2="89.879%" y1="0%" y2="43.837%">
                                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                                <stop offset="100%" stopColor="rgb(113,65,177)" stopOpacity="1" />
                            </linearGradient>

                        </defs>
                        <path fillRule="evenodd" fill="rgb(43, 142, 254)" d="M19.529,202.280 L230.531,14.698 C254.559,-6.661 291.353,-4.498 312.714,19.528 L500.295,230.531 C521.656,254.558 519.493,291.353 495.466,312.713 L284.463,500.295 C260.436,521.655 223.641,519.492 202.281,495.465 L14.699,284.462 C-6.660,260.435 -4.498,223.640 19.529,202.280 Z" />
                        <path fill="url(#PSgrad_0)" d="M19.529,202.280 L230.531,14.698 C254.559,-6.661 291.353,-4.498 312.714,19.528 L500.295,230.531 C521.656,254.558 519.493,291.353 495.466,312.713 L284.463,500.295 C260.436,521.655 223.641,519.492 202.281,495.465 L14.699,284.462 C-6.660,260.435 -4.498,223.640 19.529,202.280 Z" />
                    </svg>
                </div>
                <div className="shape-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="972.5px" height="970.5px">
                        <path fillRule="evenodd" stroke="rgb(255, 255, 255)" strokeWidth="1px" strokeLinecap="butt" strokeLinejoin="miter" fill="none" d="M38.245,381.102 L435.258,28.158 C480.467,-12.32 549.697,-7.964 589.888,37.244 L942.832,434.257 C983.23,479.466 978.955,548.697 933.746,588.888 L536.733,941.832 C491.524,982.23 422.293,977.955 382.103,932.745 L29.158,535.732 C-11.32,490.523 -6.963,421.293 38.245,381.102 Z" />
                    </svg>
                </div>
                <div className="container">
                    <div className="page-banner-wrap">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <!-- Page Banner Content Start --> */}
                                <div className="page-banner text-center">
                                    <h2 className="title">Our Services</h2>
                                    <ul className="breadcrumb justify-content-center">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Services</li>
                                    </ul>
                                </div>
                                {/* <!-- Page Banner Content End --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Page Banner End --> */}

            {/* <!-- Choose Us Start --> */}
            <div className="section techwix-choose-us-section techwix-choose-us-section-04 section-padding">
                <div className="container">
                    {/* <!-- Choose Us Wrap Start --> */}
                    <div className="choose-us-wrap">
                        <div className="choose-us-content-wrap">
                            <div className="row">
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/ser-icon9.png" alt="" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">Centralized Exchange (CEX) Development</Link></h3>
                                            <p>We build secure, high-performance centralized trading platforms with integrated KYC, multi-asset wallets, admin dashboards, and liquidity features. Designed for scalability and regulatory compliance.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/counter-3.png" alt="image" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">Decentralized Exchange (DEX) Development</Link></h3>
                                            <p>We create smart contract-driven DEX platforms with features like token swaps, staking, yield farming, and liquidity pools—supporting Ethereum, BSC, Polygon, and other chains.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/ser-icon10.png" alt="image" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">Web3 & dApp Development</Link></h3>
                                            <p>From DeFi protocols to NFT integrations and DAOs, we develop custom decentralized applications that give users true ownership and control over their digital assets.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/ser-icon12.png" alt="image" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">NFT Marketplace & Minting Solutions</Link></h3>
                                            <p>We develop NFT marketplaces with custom minting tools, royalty logic, bidding systems, and wallet integrations. Ideal for digital art, collectibles, gaming, and tokenized assets.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/counter-1.png" alt="image" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">Liquidity Bot & Market Making Tools</Link></h3>
                                            <p>Automate liquidity and trading across centralized and decentralized exchanges. Our bots help maintain tight spreads, manage inventory, and enable efficient price discovery.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/counter-2.png" alt="image" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">Wallet Integration & Infrastructure</Link></h3>
                                            <p>We integrate institutional-grade wallets like Fireblocks and BitGo, and build custom non-custodial wallets with Metamask, WalletConnect, and Web3Modal support.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/ser-icon21.png" alt="" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">Fiat On/Off Ramp Integration</Link></h3>
                                            <p>Enable seamless user onboarding with fiat-to-crypto and crypto-to-fiat conversions using trusted providers like Transak and Onramper. We handle full API integration and compliance handling.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6">
                                    {/* <!-- Choose Us Item Start --> */}
                                    <div className="choose-us-item-02">
                                        <div className="choose-us-img">
                                            <img src="/images/ser-icon22.png" alt="image" />
                                        </div>
                                        <div className="choose-us-content">
                                            <h3 className="title"><Link href="#">Custom Blockchain & Layer 1 Development</Link></h3>
                                            <p>Need your own chain or permissioned network? We build custom Layer 1 and Layer 2 blockchains with tailored consensus models, validator infrastructure, and cross-chain bridge support.</p>
                                        </div>
                                    </div>
                                    {/* <!-- Choose Us Item End --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Choose Us Wrap End --> */}
                </div>
            </div>
            {/* <!-- Choose Us End --> */}

            {/* <!-- Cta Start --> */}
            <div className="section techwix-cta-section-04 techwix-cta-section-06 techwix-cta-section-07">
                <div className="container">
                    <div className="cta-wrap"
                        style={{ backgroundImage: "url(/images/bg/cta-bg5.jpg)" }}
                    >
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                {/* <!-- Cta Left Start --> */}
                                <div className="cta-left">
                                    <div className="section-title">
                                        <h2 className="title white">To make requests for further information, contact us </h2>
                                    </div>
                                </div>
                                {/* <!-- Cta Left End --> */}
                            </div>
                            <div className="col-lg-5">
                                {/* <!-- Cta Right Start --> */}
                                <div className="cta-info text-center">
                                    <div className="cta-icon">
                                        <img src="/images/cta-icon2.png" alt="" />
                                    </div>
                                    <div className="cta-text">
                                        <p>Call Us For Any inquiry</p>
                                        <h3 className="number">+44 920 090 505</h3>
                                    </div>
                                </div>
                                {/* <!-- Cta Right End --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Cta End --> */}

            {/* <!-- Testimonial Start  --> */}
            <div className="section bg-cover techwix-testimonial-section-02 techwix-testimonial-section-03 techwix-testimonial-section-05 section-padding"
                style={{ backgroundImage: "url(/images/bg/testi-bg4.jpg)" }}
            >
                <Testimonial />
            </div>
            {/* <!-- Testimonial End  --> */}

            {/* <!-- Pricing Start --> */}
            <div className="section techwix-pricing-section section-padding-02">
                <div className="container">
                    {/* <!-- Pricing Wrap Start --> */}
                    <div className="pricing-wrap">
                        <div className="section-title text-center">
                            <h3 className="sub-title">Pricing Plans</h3>
                            <h2 className="title">Affordable pricing for all</h2>
                        </div>
                        <div className="pricing-content-wrap">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    {/* <!-- Single Pricing Start --> */}
                                    <div className="single-pricing">
                                        <div className="pricing-badge">
                                            <span className="title">Free</span>
                                        </div>
                                        <div className="pricing-price">
                                            <span className="currency">$</span>
                                            <h3 className="price">0<span>/Month</span></h3>
                                        </div>
                                        <div className="pricing-content">
                                            <ul className="pricing-list">
                                                <li>Community Support</li>
                                                <li>Dedicated Tech Experts</li>
                                                <li>Unlimited Storage</li>
                                                <li>Custom Domains</li>
                                            </ul>
                                            <div className="pricing-btn">
                                                <Link className="btn" href="#">Try It Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Single Pricing End --> */}
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    {/* <!-- Single Pricing Start --> */}
                                    <div className="single-pricing active">
                                        <div className="pricing-badge">
                                            <span className="title">Starter</span>
                                        </div>
                                        <div className="pricing-price">
                                            <span className="currency">$</span>
                                            <h3 className="price">10<span>/Month</span></h3>
                                        </div>
                                        <div className="pricing-content">
                                            <ul className="pricing-list">
                                                <li>Community Support</li>
                                                <li>Dedicated Tech Experts</li>
                                                <li>Unlimited Storage</li>
                                                <li>Custom Domains</li>
                                            </ul>
                                            <div className="pricing-btn">
                                                <Link className="btn" href="#">Try It Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Single Pricing End --> */}
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    {/* <!-- Single Pricing Start --> */}
                                    <div className="single-pricing">
                                        <div className="pricing-badge">
                                            <span className="title">Pro</span>
                                        </div>
                                        <div className="pricing-price">
                                            <span className="currency">$</span>
                                            <h3 className="price">30<span>/Month</span></h3>
                                        </div>
                                        <div className="pricing-content">
                                            <ul className="pricing-list">
                                                <li>Community Support</li>
                                                <li>Dedicated Tech Experts</li>
                                                <li>Unlimited Storage</li>
                                                <li>Custom Domains</li>
                                            </ul>
                                            <div className="pricing-btn">
                                                <Link className="btn" href="#">Try It Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Single Pricing End --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Pricing Wrap End --> */}
                </div>
            </div>
            {/* <!-- Pricing End --> */}

            {/* <!-- Brand Logo Start --> */}
            <div className="section techwix-brand-section techwix-brand-section-03">
                <div className="container">
                    {/* <!-- Brand Wrapper Start --> */}
                    <div className="brand-wrapper text-center">

                        {/* <!-- Brand Active Start --> */}
                        <div className="brand-active">
                            <div className="swiper-container">
                                <Swiper
                                    slidesPerView={5}
                                    spaceBetween={30}
                                    loop={true} // 👈 This enables infinite loop
                                    pagination={{ dynamicMainBullets: true }}
                                    //   modules={[Pagination]}
                                    className="case-swiper"
                                >

                                    {slidesBrand.map((slide, i) => (
                                        <SwiperSlide key={slide.id}>

                                            <div className="swiper-slide single-brand">
                                                <img src={slide.image} alt={`Brand ${i + 1}`} />
                                            </div>

                                        </SwiperSlide>
                                    ))}

                                </Swiper>
                            </div>
                        </div>
                        {/* <!-- Brand Active End --> */}
                    </div>
                    {/* <!-- Brand Wrapper End --> */}
                </div>
            </div>
            {/* <!-- Brand Logo End --> */}

            {/* <!-- Cta Start --> */}
            <div className="section techwix-cta-section-02 section-padding-02">
                <div className="container">
                    {/* <!-- Cta Wrap Start --> */}
                    <div className="cta-wrap"
                    >
                        <div className="row align-items-center">
                            <div className="col-xl-9 col-lg-8">
                                {/* <!-- Cta Content Start --> */}
                                <div className="cta-content">
                                    <div className="cta-icon">
                                        <img src="/images/cta-icon2.png" alt="" />
                                    </div>
                                    <p>We’re Delivering the best customer Experience</p>
                                </div>
                                {/* <!-- Cta Content End --> */}
                            </div>
                            <div className="col-xl-3 col-lg-4">
                                {/* <!-- Cta Button Start --> */}
                                <div className="cta-btn">
                                    <Link className="btn btn-white" href="#">+44 920 090 505</Link>
                                </div>
                                {/* <!-- Cta Button End --> */}
                            </div>
                        </div>
                    </div>
                    {/* <!-- Cta Wrap End --> */}
                </div>
            </div>
            {/* <!-- Cta End --> */}
            <Footer />
        </>
    );
}



export default page;